<div class="content">

  <div class="wrapper">

    <div *ngIf="!isMock" fxLayout="row" fxLayout.xs="column" fxLayoutGap="1%">
      <mat-card class="content-header" fxFlex="75%">
        <mat-card-header>
          <div class="material-icons" mat-card-avatar>insert_chart_outlined</div>
          <mat-card-title>{{strombilanzh !== undefined ? strombilanzh : ''}}</mat-card-title>
        </mat-card-header>
        <!-- <mat-card-subtitle></mat-card-subtitle> -->
        <mat-divider></mat-divider>
        <mat-card-content style="white-space: pre-line;">
          {{strombilanzt !== undefined ? strombilanzt : ''}}
        </mat-card-content>
      </mat-card>


      <mat-card fxFlex="24%">
        <mat-card-header>
          <div class="material-icons" mat-card-avatar>people</div>
          <mat-card-title>Meine Community</mat-card-title>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content>
          Wieviel Strom habe ich produziert bzw. verbraucht?
          Wie kann ich meine Strombilanz optimieren?
        </mat-card-content>
        <mat-card-actions fxLayoutAlign="center center">
          <a class="loginbtn" mat-raised-button routerLink="/community">ansehen</a>
        </mat-card-actions>
      </mat-card>


    </div>


    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">

      <div fxFlex="24%">
        <ng-container *ngFor="let powerplant of kpst_powerplants">
          <rsp-image-uploader *ngIf="!!kpst_powerplants && kpst_powerplants.length > 0" [plant]="powerplant">

          </rsp-image-uploader>
        </ng-container>

        <mat-card *ngIf="bilanzierungsText">
          {{bilanzierungsText}}
        </mat-card>
      </div>

      <div fxFlex="75%">
        <mat-card>
          <rsp-date-selection [formGroup]="dateSelectionFormGroup"></rsp-date-selection>

          <mat-tab-group (animationDone)="reflow()" (selectedTabChange)="onChangeTab($event)">
            <mat-tab label="Energieströme">

              <ng-template #spinner>
                <div class="spinner" fxLayoutAlign="center center">
                  <mat-spinner></mat-spinner>
                </div>
              </ng-template>


              <rsp-loading-wrapper [state]="chartStateCustomerData">
                <rsp-strombilanz-energie-stroeme-chart
                  [color1]="thccolor0"
                  [color2]="thccolor1"
                  [color3]="thccolor2"
                  [color4]="thccolor3"
                  [data]="_customerEnergyDatasDTO"
                  [hasError]="chartStateCustomerData.hasError">
                </rsp-strombilanz-energie-stroeme-chart>
              </rsp-loading-wrapper>

              <!--<div *ngIf="!(loading$ | async); else spinner" [chart]="energiestroeme"></div>-->

            </mat-tab>

            <mat-tab *ngIf="showAutarkieGraph" label="Autarkie-Grad">
              <rsp-loading-wrapper [state]="chartStateCustomerAutarkie">
                <rsp-strombilanz-autarkie-grad-chart
                  #graphAutarkie
                  [color1]="thccolor0"
                  [color2]="thccolor1"
                  [color3]="thccolor2"
                  [color4]="thccolor3"
                  [data]="_customerEnergyPercUsagesDTO"
                  [formGroup]="dateSelectionFormGroup"
                  [hasError]="chartStateCustomerAutarkie.hasError"
                  [percentageDisplay]="true">
                </rsp-strombilanz-autarkie-grad-chart>
              </rsp-loading-wrapper>
            </mat-tab>

            <mat-tab *ngIf="showAutarkieGraph" label="Energiemengen">
              <rsp-loading-wrapper [state]="chartStateCustomerAutarkie">
                <rsp-strombilanz-autarkie-grad-chart
                  #graphEnergieMenge
                  [color1]="thccolor0"
                  [color2]="thccolor1"
                  [color3]="thccolor2"
                  [color4]="thccolor3"
                  [data]="_customerEnergyUsagesDTO"
                  [formGroup]="dateSelectionFormGroup"
                  [hasError]="chartStateCustomerAutarkie.hasError"
                  [percentageDisplay]="false">
                </rsp-strombilanz-autarkie-grad-chart>
              </rsp-loading-wrapper>
            </mat-tab>
          </mat-tab-group>

        </mat-card>
      </div>
    </div>


  </div>

</div>
